import axios from 'axios';

export async function generateSitemapXML(locations) {
  const baseUrl = 'https://farmersmarketnear.me';
  const currentDate = new Date().toISOString().split('T')[0];
  
  let xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
    <url>
        <loc>${baseUrl}</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>daily</changefreq>
        <priority>1.0</priority>
    </url>
    <url>
        <loc>${baseUrl}/about</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
    </url>
    <url>
        <loc>${baseUrl}/contact</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
    </url>
    <url>
        <loc>${baseUrl}/privacy</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
    </url>
    <url>
        <loc>${baseUrl}/terms</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
    </url>`;

  // Add dynamic location URLs
  if (Array.isArray(locations) && locations.length > 0) {
    locations.forEach(location => {
      if (location && typeof location === 'string') {
        // Clean and format the location for URL
        const cleanLocation = location.toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
          .replace(/\s+/g, '-')         // Replace spaces with hyphens
          .replace(/-+/g, '-')          // Replace multiple hyphens with single hyphen
          .trim();                      // Trim any leading/trailing spaces or hyphens

        if (cleanLocation) {
          xml += `
    <url>
        <loc>${baseUrl}/farmers-market/${cleanLocation}</loc>
        <lastmod>${currentDate}</lastmod>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
    </url>`;
        }
      }
    });
  }

  xml += '\n</urlset>';
  return xml;
}

export async function updateSitemap(locations) {
  try {
    const sitemapXML = await generateSitemapXML(locations);
    
    // Send the updated sitemap to the Cloudflare Worker
    const response = await axios.post('https://api.farmersmarketnear.me/api/update-sitemap', {
      sitemap: sitemapXML
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.data.success) {
      throw new Error('Failed to update sitemap');
    }

    return response.data;
  } catch (error) {
    console.error('Error updating sitemap:', error.response?.data || error.message);
    throw error;
  }
}
